import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeGame from '../views/HomeGame.vue';
import Login from '../pages/Login.vue';
import DashboardPages from '../pages/DashboardPages.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'CouponLandingPage',
    component: HomeGame,
  },
  {
    path: '/dangnhap',
    name: 'AdminLogin',
    component: Login,
  },
  {
    path: '/pheonix/dashboard',
    name: 'AdminDashboard',
    component: DashboardPages,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
